import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LoginScreen } from "../LoginScreen";
import { PublicRoute } from "./PublicRoute";
import { ProtectedRoute } from "./ProtectedRoute";
import { Practice } from "../Pages/Practice";
import { Icons } from "../Pages/Icons";
import LayoutDefault from "../Pages/LayoutDefault";
import ControlPanel from "../Pages/ControlPanel";
// import VideoWallControlPage from "../Pages/VideoWallControlPage";
// import VideoWallDisplay from "../Pages/VideoWallDisplay";

export default function RoutesSwitcher(){
    return(
        <BrowserRouter>
            <Routes>
                <Route element={<PublicRoute/>}>
                    <Route path ="/" element={<LoginScreen/>} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route path="/videowall" element={<LayoutDefault />} />
                    {/* <Route path="/videowallnew" element={<VideoWallDisplay />} /> */}
                    <Route path="/controls" element={<ControlPanel />} />
                    {/* <Route path="/videowallcontrols" element={<VideoWallControlPage />} /> */}
                    <Route path="/practice" element={<Practice />} />
                    <Route path="/icons" element={<Icons />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};